var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2871 0.656617C21.2489 0.781918 22.168 1.71723 22.285 2.69263C22.699 6.26735 22.699 9.73375 22.285 13.3074C22.168 14.2828 21.2489 15.2192 20.2871 15.3434C14.4227 16.0721 8.49204 16.0721 2.62931 15.3434C1.66671 15.2189 0.747556 14.2828 0.630608 13.3074C0.216555 9.73347 0.216555 6.26735 0.630608 2.69263C0.747556 1.71723 1.66671 0.78164 2.62931 0.656617C8.49204 -0.0720826 14.4224 -0.0720826 20.2871 0.656617ZM9.60138 4.28786V11.7132L15.1703 8.00069L9.60138 4.28786Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.37d564a6c06451f3e3fbd20ddb663624.svg";
export { ForwardRef as ReactComponent };